// LUCKY DUCKY · PHASE 2 · Cardinal 20-payline geometry (LOCKED)
// Source of truth: spec/cardinal_paylines.json
// Hash (SHA-256): 536cf74674752aa70a577d848539926822121e63188ba77a02d8c23234706530
// Row convention per Cardinal: 0=top, 1=middle, 2=bottom.
// Overwrote the Phase 1 provisional set per Phase 2 build directive rule #2:
//   "Use the exact Cardinal payline map. Do NOT substitute a generic pattern."
import cardinal from '../spec/cardinal_paylines.json';

export const REEL_COUNT = 5;
export const ROW_COUNT = 3;

// Attach ids 1..20 for downstream display / audit trails.
export const PAYLINES_20 = cardinal.paylines.map((rows, i) => ({ id: i + 1, rows }));

// Sanity: hard-fail if the file mutates.
if (PAYLINES_20.length !== 20) {
  throw new Error(`Cardinal paylines.json must contain 20 lines (got ${PAYLINES_20.length})`);
}
PAYLINES_20.forEach(({ id, rows }) => {
  if (rows.length !== REEL_COUNT || rows.some(r => r < 0 || r > 2)) {
    throw new Error(`Cardinal payline ${id} malformed`);
  }
});
